let navigateRef = null;

export const setNavigate = (navigateFn) => {
  if (typeof navigateFn === 'function') {
    navigateRef = navigateFn;
  }
};

export const safeNavigate = (path, options = {}) => {
  if (navigateRef) {
    try {
      navigateRef(path, options);
      return;
    } catch (e) {
      // swallow and fallback to full reload
    }
  }
  window.location.href = path; // fallback when navigate not ready
};

export const navigateToSessionExpired = () => safeNavigate('/session-expired', { replace: true });
export const navigateToError = () => safeNavigate('/error', { replace: true });
